module.exports = "\n<div class=\"fancy-checkbox\" ng-class=\"{'fancy-checkbox-active': twoStepValidationCheckbox}\">\n\n    <div class=\"checkbox-wrap\">\n        <div class=\"checkbox-track\"></div>\n        <div class=\"checkbox-drag\"></div>\n    </div>\n    <span class=\"label label-on\" translate=\"cw.label_on\"></span>\n    <span class=\"label label-off\" translate=\"cw.label_off\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./views/directives/controls/fancy-checkbox.html
// module id = rkCg
// module chunks = 0